import { Padding } from '@mui/icons-material';
import React, { useState, useEffect, useRef } from "react";
import Cheforder from '../Ordermanagment/Food/Cheforder';
import axios from 'axios';
import MobileCheforders from '../Ordermanagment/Food/MobileCheforders';
import { Link } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader"; // ✅ Make sure you install react-spinners

const Foodchefmanagment = () => {
    const [orders, setOrders] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(false); // ✅ spinner state
    const [showDetails, setShowDetails] = useState({});
    const isMobile = window.innerWidth <= 768;
    const screenWidth = window.innerWidth;
    const containerHeight = window.innerWidth < 768
        ? '300px'       // Mobile
        : window.innerWidth < 850
            ? '300px'     // Below 850px
            : window.innerWidth < 1400
                ? '410px'   // Between 850px and 1399px
                : window.innerWidth < 1600
                    ? '500px' // Between 1400px and 1599px
                    : '640px'; // Above 1600px

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            const employeeRole = localStorage.getItem("employeRole"); // ✅ keep same key
            const role = localStorage.getItem("role"); // ✅ for ROLE_VENDOR

            if (!token) return;



            try {
                // setLoading(true); // optional: show spinner

                // 1️⃣ Fetch all orders from vendor
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const allVendorOrders = response.data || [];

                // Filter PROCESSING orders
                const processingOrders = allVendorOrders.filter(
                    (order) => order.status === "PROCESSING"
                );

                // 2️⃣ Filter TABLE_DINE_IN orders with BEING_PREPARED items
                const dineInOrders = allVendorOrders.filter(
                    (order) =>
                        order.orderType === "TABLE_DINE_IN" &&
                        Array.isArray(order.cartItems) &&
                        order.cartItems.some((item) => item.orderStatus === "BEING_PREPARED")
                );

                // 3️⃣ Fetch direct TABLE_DINE_IN orders from API
                const confirmedRes = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/BEING_PREPARED`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const directDineInOrders = confirmedRes.data || [];

                // Combine all
                let combinedOrders = [
                    ...processingOrders,
                    ...dineInOrders,
                    ...directDineInOrders,
                ];

                // console.log("🧾 All Combined Orders Before Filtering:", combinedOrders);

                // ✅ List of valid chef roles
                const validChefTypes = [
                    "Chef_North",
                    "Chef_South",
                    "Chef_Continental",
                    "Chef_Chinese",
                ];

                // ✅ Apply filtering logic
                if (role === "ROLE_VENDOR") {
                    console.log("👑 ROLE_VENDOR detected — showing all orders");
                    // alert(`👑 ROLE_VENDOR detected\nTotal Orders: ${combinedOrders.length}`);
                } else if (employeeRole && validChefTypes.includes(employeeRole)) {
                    console.log("👨‍🍳 Filtering for Employee Role:", employeeRole);

                    combinedOrders = combinedOrders.filter((order) =>
                        (order.cartItems || order.order)?.some(
                            (item) => item.chefType && item.chefType === employeeRole
                        )
                    );

                    const chefTypesFound = combinedOrders
                        .flatMap((order) =>
                            (order.cartItems || order.order)
                                ?.filter((item) => item.chefType)
                                .map((item) => item.chefType)
                        )
                        .filter(Boolean);




                } else {
                    console.warn("⚠️ No valid employee role found — showing no filtered data.");
                }

                // ✅ Update state
                setOrders(combinedOrders);
            } catch (error) {
                console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
            } finally {
                setLoading(false); // ✅ stop spinner
            }
        };

        fetchOrders();
        const intervalId = setInterval(fetchOrders, 10000); // every 10 sec
        return () => clearInterval(intervalId);
    }, [vendorId]);


    const handleItemSelect = (orderId, index) => {
        setSelectedItems((prev) => {
            const existing = prev[orderId] || [];
            const updated = existing.includes(index)
                ? existing.filter((i) => i !== index)
                : [...existing, index];
            return { ...prev, [orderId]: updated };
        });
    };

    const handleSelectAll = (orderId, itemsLength) => {
        setSelectedItems((prev) => {
            const isAllSelected = prev[orderId]?.length === itemsLength;
            const newSelection = isAllSelected ? [] : [...Array(itemsLength).keys()];
            return { ...prev, [orderId]: newSelection };
        });
    };

    const orderStages = ["Preparing", "Prepared"];

    const styles = {
        card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)" },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
        orderId: { margin: 0, fontWeight: "bold" },
        date: { fontSize: '18px', color: '#555', fontWeight: "bold" },
        pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold" },
        tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
        statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
        arrow: { margin: '0 5px' },
        dropdownBtn: {
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '90px' } : {}), // 👈 conditional style
        },
        itemList: { marginTop: '10px', fontWeight: "bold" },
        itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
    };

    const handlePreparedClick = async (order) => {
        const token = localStorage.getItem("authToken");
        if (!token) { alert("Authorization token missing"); return; }

        try {
            if (order.orderType === "TABLE_DINE_IN") {
                const status = "ORDER_IS_READY";
                const note = "Prepared successfully";
                const updatePromises = order.cartItems.map((item) =>
                    axios.put(
                        `https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(note)}`,
                        {},
                        { headers: { Authorization: `Bearer ${token}` } }
                    )
                );
                await Promise.all(updatePromises);
                setOrders((prev) =>
                    prev.map((o) =>
                        o.cartId === order.cartId
                            ? { ...o, cartItems: o.cartItems.map((item) => ({ ...item, orderStatus: status })) }
                            : o
                    )
                );
            } else {
                await axios.put(
                    `https://backend.maamaas.com/food/api/orders/edit-orders/${order.orderId}/ORDER_IS_READY`,
                    { status: "ORDER_IS_READY" },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setOrders((prev) =>
                    prev.map((o) => (o.orderId === order.orderId ? { ...o, status: "ORDER_IS_READY" } : o))
                );
            }
        } catch (error) {
            console.error("❌ Failed to update to ORDER_IS_READY:", error.response?.data || error.message);
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="row">
                <div className="col-lg-2">
                    <MobileCheforders />
                </div>
                <div className="col-lg-7 cartdta-mobilee">
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: window.innerWidth <= 425 ? " 60px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "64px" : "75px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {/* <Link 
                        to="/Newmainlandingpage" 
                        style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>Home</Link> */}
                        {/* <span className="separator"> &gt; </span> */}
                        <Link to="/fooddashboard" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>Food & Beverages</Link>
                        <span className="separator"> &gt; </span>
                        <Link style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>Chef_Managment</Link>
                    </p>

                    <div className="chef-managment" style={{ marginTop: isMobile ? "180px" : "150px" }}>
                        <h2 style={{ marginBottom: '0px', marginTop: '-40px' }} className="text-center">👨‍🍳 Chef Order Queue</h2>
                    </div>

                    {/* ✅ Spinner */}
                    {loading ? (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                            <ClipLoader color="#ff4081" size={60} />
                        </div>
                    ) : (
                        <div style={{
                            overflow: "auto",
                            height: containerHeight,
                            scrollbarWidth: "none"
                        }} >
                            {orders.map((order) => {
                                const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
                                const orderId = order.orderId || order.cartId;
                                const selected = selectedItems[orderId] || [];

                                return (
                                    <div key={orderId} style={{ ...styles.card }}>
                                        {/* Header */}
                                        <div style={styles.header}>
                                            <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                                            <button style={styles.pickupBtn} className="pickup-btn-data">
                                                {order.orderService || order.orderType || "Service"}
                                            </button>
                                            <button
                                                style={styles.dropdownBtn}
                                                onClick={() =>
                                                    setShowDetails((prev) => ({ ...prev, [orderId]: !prev[orderId] }))
                                                }
                                            >
                                                {showDetails[orderId] ? "▲" : "▼"}
                                            </button>
                                        </div>

                                        {/* Order Details */}
                                        {showDetails[orderId] && (
                                            <>
                                                <p style={styles.date}>
                                                    {order.orderDateAndTime ? (() => {
                                                        const dateObj = new Date(order.orderDateAndTime);
                                                        const date = dateObj.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" });
                                                        const time = dateObj.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
                                                        return (
                                                            <>
                                                                <span style={{ color: "black" }}>Date: </span>
                                                                <span style={{ color: "white" }}>{date}</span>
                                                                <br />
                                                                <span style={{ color: "black" }}>Time: </span>
                                                                <span style={{ color: "white" }}>{time}</span>
                                                            </>
                                                        );
                                                    })() : "N/A"}
                                                </p>

                                                {orderItems.length > 0 && (
                                                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
                                                        <thead>
                                                            <tr style={{ backgroundColor: "#b15cd6", textAlign: "center" }}>
                                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selected.length === orderItems.length}
                                                                        onChange={() => handleSelectAll(orderId, orderItems.length)}
                                                                    />
                                                                </th>
                                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>S.No</th>
                                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>Item Name</th>
                                                                <th style={{ padding: "8px", border: "1px solid #ddd" }}>Quantity</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {orderItems.map((item, index) =>
                                                                item.status === "Okay" || order.orderType === "TABLE_DINE_IN" ? (
                                                                    <tr key={index} style={{ borderBottom: "1px solid #eee", fontWeight: "bold", backgroundColor: "#d4edda" }}>
                                                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selected.includes(index)}
                                                                                onChange={() => handleItemSelect(orderId, index)}
                                                                            />
                                                                        </td>
                                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{index + 1}</td>
                                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item.dishName}</td>
                                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>{item.quantity || 1}</td>
                                                                    </tr>
                                                                ) : null
                                                            )}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </>
                                        )}

                                        {/* Order Stages Tracker */}
                                        <div style={{ ...styles.tracker, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {Array.isArray(orderStages) &&
                                                orderStages.map((stage, index) => {
                                                    let isActive = false;
                                                    let isClickable = false;

                                                    if (order.orderType !== "TABLE_DINE_IN" &&
                                                        ((order.status === "PROCESSING" && stage === "Preparing") ||
                                                            (order.status === "ORDER_IS_READY" && stage === "Prepared"))
                                                    ) {
                                                        isActive = true;
                                                        isClickable = stage === "Prepared" && order.status === "PROCESSING";
                                                    }

                                                    if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
                                                        if (stage === "Preparing" && order.cartItems.some((item) => item.orderStatus === "BEING_PREPARED")) {
                                                            isActive = true;
                                                        }
                                                        if (stage === "Prepared" && order.cartItems.some((item) => item.orderStatus === "ORDER_IS_READY")) {
                                                            isActive = true;
                                                            isClickable = true;
                                                        }
                                                    }

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div
                                                                onClick={() => { if (stage === "Prepared") handlePreparedClick(order); }}
                                                                style={{
                                                                    ...styles.statusBox,
                                                                    backgroundColor: isActive ? "green" : "#f0f0f0",
                                                                    color: isActive ? "white" : "black",
                                                                    borderRadius: "6px",
                                                                    padding: "8px 12px",
                                                                    fontWeight: "bold",
                                                                    textTransform: "uppercase",
                                                                    cursor: isClickable ? "pointer" : "default",
                                                                }}
                                                            >
                                                                {stage}
                                                            </div>
                                                            {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                                                        </React.Fragment>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="col-lg-3">
                    <Cheforder />
                </div>
            </div>
        </div>
    );
};

export default Foodchefmanagment;
